/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AcceptWorkspaceInvitationImport } from './routes/accept-workspace-invitation'
import { Route as IndexImport } from './routes/index'
import { Route as GhInstallationRedirectImport } from './routes/gh-installation.redirect'
import { Route as DashOnboardingImport } from './routes/dash.onboarding'
import { Route as EditorOrganizationSlugWorkspaceSlugImport } from './routes/editor.$organizationSlug.$workspaceSlug'
import { Route as DashOrganizationSlugPricingImport } from './routes/dash.$organizationSlug.pricing'
import { Route as DashOrganizationSlugHomeImport } from './routes/dash.$organizationSlug.home'
import { Route as DashOrganizationSlugWorkspaceSlugEditImport } from './routes/dash.$organizationSlug.$workspaceSlug.edit'
import { Route as EditorOrganizationSlugWorkspaceSlugDraftsDraftIdImport } from './routes/editor_.$organizationSlug.$workspaceSlug.drafts.$draftId'

// Create Virtual Routes

const TosLazyImport = createFileRoute('/tos')()
const PrivacyLazyImport = createFileRoute('/privacy')()
const LoginLazyImport = createFileRoute('/login')()
const ForceLogoutLazyImport = createFileRoute('/force-logout')()
const AboutLazyImport = createFileRoute('/about')()
const OauthGoogleRedirectLazyImport = createFileRoute(
  '/oauth/google/redirect',
)()
const OauthGithubRedirectLazyImport = createFileRoute(
  '/oauth/github/redirect',
)()

// Create/Update Routes

const TosLazyRoute = TosLazyImport.update({
  path: '/tos',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/tos.lazy').then((d) => d.Route))

const PrivacyLazyRoute = PrivacyLazyImport.update({
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/privacy.lazy').then((d) => d.Route))

const LoginLazyRoute = LoginLazyImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))

const ForceLogoutLazyRoute = ForceLogoutLazyImport.update({
  path: '/force-logout',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/force-logout.lazy').then((d) => d.Route))

const AboutLazyRoute = AboutLazyImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const AcceptWorkspaceInvitationRoute = AcceptWorkspaceInvitationImport.update({
  path: '/accept-workspace-invitation',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const GhInstallationRedirectRoute = GhInstallationRedirectImport.update({
  path: '/gh-installation/redirect',
  getParentRoute: () => rootRoute,
} as any)

const DashOnboardingRoute = DashOnboardingImport.update({
  path: '/dash/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const OauthGoogleRedirectLazyRoute = OauthGoogleRedirectLazyImport.update({
  path: '/oauth/google/redirect',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/oauth.google.redirect.lazy').then((d) => d.Route),
)

const OauthGithubRedirectLazyRoute = OauthGithubRedirectLazyImport.update({
  path: '/oauth/github/redirect',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/oauth.github.redirect.lazy').then((d) => d.Route),
)

const EditorOrganizationSlugWorkspaceSlugRoute =
  EditorOrganizationSlugWorkspaceSlugImport.update({
    path: '/editor/$organizationSlug/$workspaceSlug',
    getParentRoute: () => rootRoute,
  } as any)

const DashOrganizationSlugPricingRoute =
  DashOrganizationSlugPricingImport.update({
    path: '/dash/$organizationSlug/pricing',
    getParentRoute: () => rootRoute,
  } as any)

const DashOrganizationSlugHomeRoute = DashOrganizationSlugHomeImport.update({
  path: '/dash/$organizationSlug/home',
  getParentRoute: () => rootRoute,
} as any)

const DashOrganizationSlugWorkspaceSlugEditRoute =
  DashOrganizationSlugWorkspaceSlugEditImport.update({
    path: '/dash/$organizationSlug/$workspaceSlug/edit',
    getParentRoute: () => rootRoute,
  } as any)

const EditorOrganizationSlugWorkspaceSlugDraftsDraftIdRoute =
  EditorOrganizationSlugWorkspaceSlugDraftsDraftIdImport.update({
    path: '/editor/$organizationSlug/$workspaceSlug/drafts/$draftId',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/accept-workspace-invitation': {
      id: '/accept-workspace-invitation'
      path: '/accept-workspace-invitation'
      fullPath: '/accept-workspace-invitation'
      preLoaderRoute: typeof AcceptWorkspaceInvitationImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/force-logout': {
      id: '/force-logout'
      path: '/force-logout'
      fullPath: '/force-logout'
      preLoaderRoute: typeof ForceLogoutLazyImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyLazyImport
      parentRoute: typeof rootRoute
    }
    '/tos': {
      id: '/tos'
      path: '/tos'
      fullPath: '/tos'
      preLoaderRoute: typeof TosLazyImport
      parentRoute: typeof rootRoute
    }
    '/dash/onboarding': {
      id: '/dash/onboarding'
      path: '/dash/onboarding'
      fullPath: '/dash/onboarding'
      preLoaderRoute: typeof DashOnboardingImport
      parentRoute: typeof rootRoute
    }
    '/gh-installation/redirect': {
      id: '/gh-installation/redirect'
      path: '/gh-installation/redirect'
      fullPath: '/gh-installation/redirect'
      preLoaderRoute: typeof GhInstallationRedirectImport
      parentRoute: typeof rootRoute
    }
    '/dash/$organizationSlug/home': {
      id: '/dash/$organizationSlug/home'
      path: '/dash/$organizationSlug/home'
      fullPath: '/dash/$organizationSlug/home'
      preLoaderRoute: typeof DashOrganizationSlugHomeImport
      parentRoute: typeof rootRoute
    }
    '/dash/$organizationSlug/pricing': {
      id: '/dash/$organizationSlug/pricing'
      path: '/dash/$organizationSlug/pricing'
      fullPath: '/dash/$organizationSlug/pricing'
      preLoaderRoute: typeof DashOrganizationSlugPricingImport
      parentRoute: typeof rootRoute
    }
    '/editor/$organizationSlug/$workspaceSlug': {
      id: '/editor/$organizationSlug/$workspaceSlug'
      path: '/editor/$organizationSlug/$workspaceSlug'
      fullPath: '/editor/$organizationSlug/$workspaceSlug'
      preLoaderRoute: typeof EditorOrganizationSlugWorkspaceSlugImport
      parentRoute: typeof rootRoute
    }
    '/oauth/github/redirect': {
      id: '/oauth/github/redirect'
      path: '/oauth/github/redirect'
      fullPath: '/oauth/github/redirect'
      preLoaderRoute: typeof OauthGithubRedirectLazyImport
      parentRoute: typeof rootRoute
    }
    '/oauth/google/redirect': {
      id: '/oauth/google/redirect'
      path: '/oauth/google/redirect'
      fullPath: '/oauth/google/redirect'
      preLoaderRoute: typeof OauthGoogleRedirectLazyImport
      parentRoute: typeof rootRoute
    }
    '/dash/$organizationSlug/$workspaceSlug/edit': {
      id: '/dash/$organizationSlug/$workspaceSlug/edit'
      path: '/dash/$organizationSlug/$workspaceSlug/edit'
      fullPath: '/dash/$organizationSlug/$workspaceSlug/edit'
      preLoaderRoute: typeof DashOrganizationSlugWorkspaceSlugEditImport
      parentRoute: typeof rootRoute
    }
    '/editor/$organizationSlug/$workspaceSlug/drafts/$draftId': {
      id: '/editor/$organizationSlug/$workspaceSlug/drafts/$draftId'
      path: '/editor/$organizationSlug/$workspaceSlug/drafts/$draftId'
      fullPath: '/editor/$organizationSlug/$workspaceSlug/drafts/$draftId'
      preLoaderRoute: typeof EditorOrganizationSlugWorkspaceSlugDraftsDraftIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AcceptWorkspaceInvitationRoute,
  AboutLazyRoute,
  ForceLogoutLazyRoute,
  LoginLazyRoute,
  PrivacyLazyRoute,
  TosLazyRoute,
  DashOnboardingRoute,
  GhInstallationRedirectRoute,
  DashOrganizationSlugHomeRoute,
  DashOrganizationSlugPricingRoute,
  EditorOrganizationSlugWorkspaceSlugRoute,
  OauthGithubRedirectLazyRoute,
  OauthGoogleRedirectLazyRoute,
  DashOrganizationSlugWorkspaceSlugEditRoute,
  EditorOrganizationSlugWorkspaceSlugDraftsDraftIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/accept-workspace-invitation",
        "/about",
        "/force-logout",
        "/login",
        "/privacy",
        "/tos",
        "/dash/onboarding",
        "/gh-installation/redirect",
        "/dash/$organizationSlug/home",
        "/dash/$organizationSlug/pricing",
        "/editor/$organizationSlug/$workspaceSlug",
        "/oauth/github/redirect",
        "/oauth/google/redirect",
        "/dash/$organizationSlug/$workspaceSlug/edit",
        "/editor/$organizationSlug/$workspaceSlug/drafts/$draftId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/accept-workspace-invitation": {
      "filePath": "accept-workspace-invitation.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/force-logout": {
      "filePath": "force-logout.lazy.tsx"
    },
    "/login": {
      "filePath": "login.lazy.tsx"
    },
    "/privacy": {
      "filePath": "privacy.lazy.tsx"
    },
    "/tos": {
      "filePath": "tos.lazy.tsx"
    },
    "/dash/onboarding": {
      "filePath": "dash.onboarding.tsx"
    },
    "/gh-installation/redirect": {
      "filePath": "gh-installation.redirect.tsx"
    },
    "/dash/$organizationSlug/home": {
      "filePath": "dash.$organizationSlug.home.tsx"
    },
    "/dash/$organizationSlug/pricing": {
      "filePath": "dash.$organizationSlug.pricing.tsx"
    },
    "/editor/$organizationSlug/$workspaceSlug": {
      "filePath": "editor.$organizationSlug.$workspaceSlug.tsx"
    },
    "/oauth/github/redirect": {
      "filePath": "oauth.github.redirect.lazy.tsx"
    },
    "/oauth/google/redirect": {
      "filePath": "oauth.google.redirect.lazy.tsx"
    },
    "/dash/$organizationSlug/$workspaceSlug/edit": {
      "filePath": "dash.$organizationSlug.$workspaceSlug.edit.tsx"
    },
    "/editor/$organizationSlug/$workspaceSlug/drafts/$draftId": {
      "filePath": "editor_.$organizationSlug.$workspaceSlug.drafts.$draftId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
